import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/userSlice";

function Breadcrumbs({ path }) {
  const State = useSelector(selectUser);
  const { userDetails } = State;

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        {path.map((item, index) => (
          <div key={index}>
            {index === 0 && (
              <li className="inline-flex items-center">
                <Link
                  to={`/${path[0].toString().replace(/ /g, "_").toLowerCase()}`}
                  className="inline-flex items-center text-secondary hover:!text-[#FFFFFF]"
                >
                  {item}
                </Link>
              </li>
            )}
            {index > 0 && (
              <li>
                <div className="flex items-center">
                  <svg
                    aria-hidden="true"
                    className="w-6 h-6 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <Link
                    to={
                      item === "Teams"
                        ? `/${path
                            .slice(0, index + 1)
                            .join("/")
                            .replace(/ /g, "_")
                            .toLowerCase()}/${userDetails?.user?.id}`
                        : `/${path
                            .slice(0, index + 1)
                            .join("/")
                            .replace(/ /g, "_")
                            .toLowerCase()}`
                    }
                    className={`ml-1 inline-flex items-center text-secondary ${
                      path.length - 1 === index
                        ? "!text-[#FFFFFF]"
                        : "hover:!text-[#FFFFFF]"
                    } ${index > 1 ? "pointer-events-none" : ""}`}
                  >
                    {item}
                  </Link>
                </div>
              </li>
            )}
          </div>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
